export { HijriModule } from './ngx-hijri.module';
export { HijriService } from './ngx-hijri.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/index.ts